import { t } from "i18next";
import React, { useEffect, useState } from "react";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { FormControlLabel, IconButton, Radio, RadioGroup } from "@mui/material";
import {
  useAssignCapabilityQuery,
  useCreateRoleMutation,
  useGetCapabilityQuery,
  useGetRoleByIdQuery,
  useRevokeCapabilityQuery,
  useUpdateRoleMutation,
} from "../../api/admin/rolesApi";
import { toast } from "react-toastify";
import CheckBoxRoundedIcon from "@mui/icons-material/CheckBoxRounded";
import CheckBoxOutlineBlankRoundedIcon from "@mui/icons-material/CheckBoxOutlineBlankRounded";

const DetailRuoli = ({ roleId, onClose }) => {
  const [capability, setCapability] = useState();
  const [assign, setAssign] = useState();
  const [revoke, setRevoke] = useState();
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    enabled: false,
  });

  const [validationErrors, setValidationErrors] = useState({});

  const { data: dataIdRole } = useGetRoleByIdQuery(roleId, { skip: !roleId });
  const { data: getCapability } = useGetCapabilityQuery();
  const [createRole, { isLoading: loadingCreate }] = useCreateRoleMutation();
  const [editRole, { isLoading: loadingEdit }] = useUpdateRoleMutation();

  const { refetch: refetchAssign } = useAssignCapabilityQuery(
    { id: roleId, capabilityId: assign },
    { skip: !assign }
  );

  const { refetch: refetchRevoke } = useRevokeCapabilityQuery(
    { id: roleId, capabilityId: revoke },
    { skip: !revoke }
  );

  useEffect(() => {
    if (assign) {
      refetchAssign().then(() => {
        setFormData((prevData) => ({
          ...prevData,
          capabilities: [...prevData.capabilities, assign],
        }));
        setAssign(null);
      });
    }
  }, [assign, refetchAssign]);

  useEffect(() => {
    if (revoke) {
      refetchRevoke().then(() => {
        setFormData((prevData) => ({
          ...prevData,
          capabilities: prevData.capabilities.filter((id) => id !== revoke),
        }));
        setRevoke(null);
      });
    }
  }, [revoke, refetchRevoke]);

  useEffect(() => {
    if (roleId && dataIdRole && dataIdRole.Data) {
      setFormData({
        id: dataIdRole.Data.id,
        name: dataIdRole.Data.name,
        enabled: true,
        capabilities: dataIdRole.Data.capabilities?.map((el) => el.id),
      });
    }
  }, [roleId, dataIdRole]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeRadio = (event) => {
    setFormData({ ...formData, enabled: event.target.value === "true" });
  };

  const handleAssignCapability = (id) => {
    setAssign(id);
  };

  const handleRevokeCapability = (id) => {
    setRevoke(id);
  };

  const handleSave = () => {
    try {
      const bodyRole = {
        id: formData.id,
        name: formData.name,
      };

      if (roleId) {
        editRole(bodyRole)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("RolesPermitted") + " " + t("not edited"));
              return;
            } else {
              toast.success(t("RolesPermitted") + " " + t("Updated"));
              onClose();
            }
          });
      } else {
        createRole(bodyRole)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("RolesPermitted") + " " + t("not edited"));
              return;
            }
            toast.success(t("RolesPermitted") + " " + t("Created"));
            onClose();
          });
      }
    } catch (err) {
      toast.error(t("ReqErr"));
      console.log(err);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <h2>
        {roleId
          ? t("Edit") + " " + t("RolesPermitted")
          : t("Created") + " " + t("RolesPermitted")}
      </h2>
      <div className="flex justify-center w-full space-x-8 p-8">
        <div className=" w-6/12">
          {roleId && (
            <div className="flex justify-between items-center pt-4">
              <h3 className="m-0">{t("Stato ruolo")}</h3>

              <RadioGroup
                row
                value={formData.enabled}
                className="flex"
                onChange={handleChangeRadio}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio size="small" />}
                  label={t("Attivo")}
                />
                <FormControlLabel
                  value={false}
                  control={<Radio size="small" />}
                  label={t("Disattivo")}
                />
              </RadioGroup>
            </div>
          )}
          <CoreInputField
            className="w-full"
            label="Id"
            name="id"
            onChange={handleChange}
            value={formData.id}
          />
          <CoreInputField
            className="w-full"
            label={t("Name")}
            name="name"
            onChange={handleChange}
            value={formData?.name}
          />
          <div className="flex justify-around mt-4 py-8">
            <CoreButton
              testo={
                loadingCreate ? t("Wait") : roleId ? t("Save") : t("Create")
              }
              className="bg-primary btn-round border-primary"
              onClick={handleSave}
              disabled={loadingCreate || loadingEdit}
            />
          </div>
        </div>
        {roleId && (
          <div className="w-6/12">
            <h3>Aggiungi o rimuovi le {t("Capability")} </h3>

            <div
              className="mt-8 p-4  "
              style={{
                border: "1px solid lightgrey",
              }}
            >
              {getCapability?.Data?.map((el, index) => (
                <div className="flex m-0" key={index}>
                  {formData.capabilities?.includes(el.id) ? (
                    <div>
                      <IconButton
                        onClick={() => handleRevokeCapability(el.id)}
                        className="w-10 h-10 text-blue-600 m-0"
                      >
                        <CheckBoxRoundedIcon />
                      </IconButton>
                      {el.description}
                    </div>
                  ) : (
                    <div>
                      <IconButton
                        className="w-10 h-10 text-blue-600"
                        onClick={() => handleAssignCapability(el.id)}
                      >
                        <CheckBoxOutlineBlankRoundedIcon />
                      </IconButton>
                      {el.description}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailRuoli;
